module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-200.0a1c146f.woff";